export default __webpack_public_path__ + "dbf853b6375b2b5ba8ec5f9c3ca78700.png";